<template>
  <Main>
    <ToolsPanel
      :breadCrumbFirst="$t('report.countryStatsTitle')"
      :title="$t('report.countryStatsTitle')"
    >
      <div class="list__buttons"></div>
    </ToolsPanel>
    <ContentContainer>
      <div class="list__filter">
        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('country', [])"
              v-if="filterData.country.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.country.length > 0">
                  {{ filterData.country[0].enName }}

                  <template v-if="filterData.country.length > 1">
                    +{{ filterData.country.length - 1 }}
                  </template>
                </template>
                <template v-else> Countries </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_country" placeholder="Search Country" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.country"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('country', item)"
                  >
                    {{ item.enName }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('country', item)"
                  v-for="item in getCheckList('countryList', 'search_country', 'enName', 'country')"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.enName }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('exclude_country', [])"
              v-if="filterData.exclude_country.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.exclude_country.length > 0">
                  {{ filterData.exclude_country[0].enName }}

                  <template v-if="filterData.exclude_country.length > 1">
                    +{{ filterData.exclude_country.length - 1 }}
                  </template>
                </template>
                <template v-else> Exclude Country </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_exclude_country" placeholder="Search Country" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.exclude_country"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('exclude_country', item)"
                  >
                    {{ item.enName }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('exclude_country', item)"
                  v-for="item in getCheckList(
                    'countryList',
                    'search_exclude_country',
                    'enName',
                    'exclude_country',
                  )"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.enName }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('language_id', [])"
              v-if="filterData.language_id.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.language_id.length > 0">
                  {{ filterData.language_id[0].code }}

                  <template v-if="filterData.language_id.length > 1">
                    +{{ filterData.language_id.length - 1 }}
                  </template>
                </template>
                <template v-else> Languages </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_language" placeholder="Search Language" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.language_id"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('language_id', item)"
                  >
                    {{ item.code }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('language_id', item)"
                  v-for="item in getCheckList(
                    'languagesList',
                    'search_language',
                    'code',
                    'language_id',
                  )"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.code }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('direction', [])"
              v-if="filterData.direction.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.direction.length > 0">
                  {{ filterData.direction[0].name }}

                  <template v-if="filterData.direction.length > 1">
                    +{{ filterData.direction.length - 1 }}
                  </template>
                </template>
                <template v-else> Direction </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.direction"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('direction', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('direction', item)"
                  v-for="item in directionList"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <input
            type="text"
            v-model="filterData.campaign_internal"
            placeholder="campaign internal"
          />
        </div>
        <div class="list__filter-item">
          <input
            type="text"
            v-model="filterData.campaign_external"
            placeholder="campaign external"
          />
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('integration', [])"
              v-if="filterData.integration.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.integration.length > 0">
                  {{ filterData.integration[0].name }}

                  <template v-if="filterData.integration.length > 1">
                    +{{ filterData.integration.length - 1 }}
                  </template>
                </template>
                <template v-else> Integrations </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_integration" placeholder="Search Integration" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.integration"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('integration', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('integration', item)"
                  v-for="item in getCheckList(
                    'integrationList',
                    'search_integration',
                    'name',
                    'integration',
                  )"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('exclude_integration', [])"
              v-if="filterData.exclude_integration.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.exclude_integration.length > 0">
                  {{ filterData.exclude_integration[0].name }}

                  <template v-if="filterData.exclude_integration.length > 1">
                    +{{ filterData.exclude_integration.length - 1 }}
                  </template>
                </template>
                <template v-else> Exclude Integration </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_exclude_integration" placeholder="Search Integration" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.exclude_integration"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('exclude_integration', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('exclude_integration', item)"
                  v-for="item in getCheckList(
                    'integrationList',
                    'search_exclude_integration',
                    'name',
                    'exclude_integration',
                  )"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('status', [])"
              v-if="filterData.status.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.status.length > 0">
                  {{ filterData.status[0].name }}

                  <template v-if="filterData.status.length > 1">
                    +{{ filterData.status.length - 1 }}
                  </template>
                </template>
                <template v-else> Status </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_status" placeholder="Search Status" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.status"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('status', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('status', item)"
                  v-for="item in getCheckList('statusList', 'search_status', 'name', 'status')"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <MainSelect
            :id="'deposit'"
            :placeholder="'FTD'"
            :option-list="depositList"
            :set-value="filterData"
            :value="filterData.deposit"
            :labelName="'name'"
          />
        </div>

        <div v-if="!bayer" class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('bayer', [])"
              v-if="filterData.bayer.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.bayer.length > 0">
                  {{ filterData.bayer[0].email }}

                  <template v-if="filterData.bayer.length > 1">
                    +{{ filterData.bayer.length - 1 }}
                  </template>
                </template>
                <template v-else> Bayer </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_bayer" placeholder="Search Bayer" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.bayer"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('bayer', item)"
                  >
                    {{ item.email }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('bayer', item)"
                  v-for="item in getCheckList('bayerList', 'search_bayer', 'email', 'bayer')"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.email }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!bayer" class="list__filter-item">
          <div class="check-selector">
            <div
              @click="resetCheck('team', [])"
              v-if="filterData.team.length > 0"
              class="check-selector__reset"
            >
              <svg
                data-v-6ab518a4=""
                xmlns="http://www.w3.org/2000/svg"
                width="20px"
                height="20px"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g data-v-6ab518a4="" id="Menu / Close_MD">
                  <path
                    data-v-6ab518a4=""
                    id="Vector"
                    d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
                    stroke="#000000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="check-selector__button">
              <div class="check-selector__button-name">
                <template v-if="filterData.team.length > 0">
                  {{ filterData.team[0].name }}

                  <template v-if="filterData.team.length > 1">
                    +{{ filterData.team.length - 1 }}
                  </template>
                </template>
                <template v-else> Team </template>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" role="presentation">
                <path
                  d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                ></path>
              </svg>
            </div>

            <div class="check-selector__list">
              <div class="check-selector__list-container">
                <div class="check-selector__search">
                  <input v-model="search_team" placeholder="Search Team" />
                </div>
                <div class="check-selector__check-items">
                  <div
                    v-for="item in filterData.team"
                    :key="item.id"
                    class="check-selector__check-item"
                    @click="removeCheckElement('team', item)"
                  >
                    {{ item.name }} <span>-</span>
                  </div>
                </div>
                <div
                  @click="addCheckElement('team', item)"
                  v-for="item in getCheckList('teamList', 'search_team', 'name', 'team')"
                  :key="item.id"
                  class="check-selector__list-item"
                >
                  {{ item.name }} <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list__filter-item">
          <b>from: </b>
          <DatePicker v-model="filterData.created_at_from" :format="'DD.MM.YYYY'" />
        </div>
        <div class="list__filter-item">
          <b>to: </b>
          <DatePicker v-model="filterData.created_at_to" :format="'DD.MM.YYYY'" />
        </div>

        <div class="list__filter-button">
          <MainButton @click.native="filterList()">Filter</MainButton>
        </div>
        <div class="list__filter-button">
          <MainButton @click.native="filterListReset()">Reset</MainButton>
        </div>
        <!-- <div class="list__filter-button">
          <MainButton @click.native="exportLead()">Export</MainButton>
        </div> -->
      </div>

      <div class="list country">
        <div v-if="leadsList.length">
          <CustomTable
            v-if="leadsList.length"
            :data="leadsList"
            :deleted-keys="tableOptions.deletedKeys"
            :rename-columns="tableOptions.renameColumn"
            :custom-order="tableOptions.customOrder"
            :is-action-block-visible="tableOptions.isActionBlockVisible"
            :handleFilter="handleFilter"
            :direction="directionSort"
            :noSortColumn="tableOptions.noSortColumn"
            :order="orderSort"
            :isAllChosen="isAllChosen"
            :rowArrayId="rowArrayId"
            :name="'country'"
          >
            <template v-slot:extra>
              <div class="custom-table__row row-total total">
                <div class="custom-table__row-item"><b>Total</b></div>
                <div class="custom-table__row-item">
                  {{ statistics.crLeads }}
                </div>
                <div class="custom-table__row-item">
                  {{ statistics.crMtm }}
                </div>
                <div class="custom-table__row-item">
                  {{ statistics.ftd }}
                </div>
                <div class="custom-table__row-item">
                  {{ statistics.ftdMtm }}
                </div>
                <div class="custom-table__row-item">
                  {{ statistics.leads }}
                </div>
                <div class="custom-table__row-item">-</div>
                <div class="custom-table__row-item">-</div>
                <div class="custom-table__row-item">-</div>
              </div>
            </template>
          </CustomTable>
        </div>
        <div class="list__no-have" v-else>No leads found by this parameter.</div>
      </div>
    </ContentContainer>
    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />

    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import leadApi from "~/api/lead";
import userApi from "~/api/user";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import keysToSnakeCase from "snakecase-keys";
import { getStoredUserInfo } from "~/helpers/userAuth";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import CustomTable from "~/components/molecules/CustomTable.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import MainModal from "~/components/molecules/MainModal.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import MainSelect from "~/components/atoms/inputs/MainSelect.vue";

export default {
  name: "CountryDeposit",
  metaInfo() {
    return {
      title: this.$t("report.countryStatsTitle"),
    };
  },
  data() {
    return {
      admin: false,
      team_lead: false,
      bayer: false,
      canDelete: false,

      leads: {},
      leadsList: [],
      statistics: [],

      search_country: "",
      search_exclude_country: "",
      search_exclude_integration: "",
      search_language: "",
      search_integration: "",
      search_status: "",
      search_bayer: "",
      search_team: "",

      logsModal: false,
      logsModalArray: [],
      deleteModal: false,
      deleteRow: null,
      deleteModalSuccess: false,
      directionSort: false,
      orderSort: "country_name",
      perPage: 20,
      perPageList: [20, 40, 60, 80, 100],

      detailModal: false,
      chosenLead: null,
      distribution_log: null,
      logStatus: [],
      logList: [],

      rowArrayId: [],
      isAllChosen: false,

      filterData: {
        id: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        integration: [],
        exclude_integration: [],
        country: [],
        exclude_country: [],
        status: [],
        campaign_internal: "",
        campaign_external: "",
        created_at_from: null,
        created_at_to: null,
        language_id: [],
        deposit: null,
        bayer: [],
        team: [],
        direction: [],
      },
      isFilter: false,
      countryList: [],
      statusList: [],
      integrationList: [],
      integrationAvailable: [],
      languagesList: [],
      bayerList: [],
      teamList: [],
      depositList: [
        {
          name: "All",
          id: "all",
        },
        {
          name: "Yes",
          id: "1",
        },
        {
          name: "No",
          id: "0",
        },
      ],
      directionList: [
        {
          name: this.$t("region.europe"),
          id: "eu",
        },
        {
          name: this.$t("region.australia"),
          id: "au",
        },
        {
          name: this.$t("region.canada"),
          id: "ca",
        },
      ],
      sendData: {
        integration: null,
      },

      tableOptions: {
        deletedKeys: ["null", "isDuplicated", "statusId"],
        noSortColumn: [],
        isActionBlockVisible: true,
        renameColumn: [
          {
            from: "country_name",
            to: "Country Name",
          },
          {
            from: "cr_leads",
            to: "CR Leads",
          },
          {
            from: "cr_mtm",
            to: "CR Mtm",
          },
          {
            from: "ftd",
            to: "FTD",
          },
          {
            from: "ftd_mtm",
            to: "FTD Mtm",
          },
          {
            from: "leads",
            to: "Leads",
          },
          {
            from: "percent_of_leads",
            to: "Leads %",
          },
          {
            from: "percent_of_ftd",
            to: "FTD %",
          },
          {
            from: "percent_of_ftd_mtm",
            to: "FTD Mtm %",
          },
        ],
        customOrder: [
          "country_name",
          "cr_leads",
          "cr_mtm",
          "ftd",
          "ftd_mtm",
          "leads",
          "percent_of_leads",
          "percent_of_ftd",
          "percent_of_ftd_mtm",
          "null",
        ],
      },
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    CustomTable,
    // Pagination,
    // MainModal,
    ModalError,
    MainSelect,
    DatePicker,
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeyDown);
  },
  mounted() {
    window.addEventListener("keydown", this.onKeyDown);

    if (getStoredUserInfo()) {
      this.user = getStoredUserInfo();
      if (
        this.user.groups[0].id == 2 ||
        this.user.groups[0].id == 6 ||
        this.user.groups[0].id == 5
      ) {
        this.admin = true;
      } else if (this.user.groups[0].id == 4) {
        this.team_lead = true;
      } else if (this.user.groups[0].id == 3) {
        this.bayer = true;
      }

      if (this.user.groups[0].id == 2 || this.user.groups[0].id == 5) {
        this.canDelete = true;
      }
    }

    this.getIntegrationAll();

    this.getLogStatus();
    this.getCountry();
    this.getLeadStatus();
    this.getLanguage();
    this.getBayer();
    this.getTeam();
    this.setQueryParams();
  },
  watch: {
    $route(to, from) {
      this.getList();
    },
  },
  computed: {
    ...mapState("lead", ["error", "loadingProcess"]),
    ...mapState("lead", ["queue"]),
    page() {
      if (this.$route.params.page) {
        return +this.$route.params.page;
      } else {
        return 1;
      }
    },
    getQueryParameters() {
      const query = this.$route.fullPath.split("?")[1];
      if (query) {
        return `?${query}`;
      } else {
        return "";
      }
    },
  },
  methods: {
    onKeyDown(e) {
      if (e.key === "Enter") {
        this.filterList();
      }
    },
    getCheckList(listKey, filterKey, nameKey, chooseItem) {
      const arr = this?.[listKey];
      const rawFilter = this?.[filterKey];

      if (!Array.isArray(arr)) return [];

      // список выбранных id
      const selectedIds = Array.isArray(this.filterData[chooseItem])
        ? this.filterData[chooseItem].map((item) => item?.id)
        : [];

      const filterStr =
        rawFilter == null || String(rawFilter).trim() === ""
          ? null
          : String(rawFilter).toLowerCase().trim();

      return arr.filter((item) => {
        // ❌ исключаем если id уже выбран
        if (selectedIds.includes(item?.id)) return false;

        // если фильтра нет — возвращаем всё кроме выбранных
        if (!filterStr) return true;

        const val = item?.[nameKey];
        if (val == null) return false;

        return String(val).toLowerCase().includes(filterStr);
      });
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm:ss");
    },
    toSnakeCase(data) {
      return keysToSnakeCase(data, { deep: true });
    },
    async getCountry() {
      await leadApi
        .getCountryList()
        .then((res) => {
          this.countryList = res.data.items;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getLeadStatus() {
      await leadApi
        .getLeadStatus()
        .then((res) => {
          this.statusList = res.data.items;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getIntegrationAll() {
      await leadApi
        .getIntegrationAll()
        .then((res) => {
          this.integrationList = res.data;
          this.integrationAvailable = res.data;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getIntegrationAvailable() {
      await leadApi
        .getIntegrationListAvailable()
        .then((res) => {
          this.integrationAvailable = Object.values(res.data);
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getLanguage() {
      await leadApi
        .getLanguageList()
        .then((res) => {
          this.languagesList = res.data.items;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getBayer() {
      await userApi
        .getBayerAll()
        .then((res) => {
          this.bayerList = res.data;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async getTeam() {
      await userApi
        .getTeamAll()
        .then((res) => {
          this.teamList = res.data.items;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    async sendLead() {
      this.$store.commit("lead/setLoading", true);
      if (this.sendData.integration && this.chosenLead) {
        const data = {};
        data.lead_id = this.chosenLead.id;
        data.integration_id = this.sendData.integration.id;
        data.client_id = this.sendData.integration.clientId;
        await leadApi
          .sendLead(data)
          .then((res) => {
            this.$store.commit("lead/setLoading", false);
          })
          .catch((error) => {
            this.$store.commit("lead/setLoading", false);
          })
          .finally(() => {});
      }
    },

    addRowArray(id) {
      this.rowArrayId.push(id);
      this.checkAllRow();
    },
    addAllRowArray() {
      this.leadsList.forEach((item) => {
        if (!this.rowArrayId.includes(item.id)) {
          this.rowArrayId.push(item.id);
        }
      });
      this.isAllChosen = true;
      this.checkAllRow();
    },
    deleteRowArray(targetId) {
      this.rowArrayId = this.rowArrayId.filter((id) => id !== targetId);
      this.checkAllRow();
    },
    deleteAllRowArray() {
      this.leadsList.forEach((item) => {
        this.rowArrayId = this.rowArrayId.filter((id) => id !== item.id);
      });
      this.isAllChosen = false;
      this.checkAllRow();
    },

    uncheckAllRow() {
      this.rowArrayId = [];
      this.checkAllRow();
    },
    checkAllRow() {
      let noHave = false;
      this.leadsList.forEach((item) => {
        if (!this.rowArrayId.includes(item.id)) {
          noHave = true;
        }
      });

      if (noHave) {
        this.isAllChosen = false;
      } else {
        this.isAllChosen = true;
      }
    },
    reimport() {
      const leads = [];

      this.rowArrayId.forEach((item) => {
        leads.push({
          id: item,
        });
      });

      const data = {
        leads: leads,
      };
      console.log(data);
      this.$store.commit("lead/setLoading", true);

      leadApi
        .leadReimport(data)
        .then((res) => {
          this.uncheckAllRow();
          this.getList();
        })
        .catch((error) => {
          const { data } = error.response;
        })
        .finally(() => {
          this.$store.commit("lead/setLoading", false);
        });
    },
    getStatusLog(id) {
      const name = this.logStatus.find((i) => {
        return i.id == id;
      });

      if (name) {
        return name.name;
      }
    },
    getList() {
      let url = "";
      if (this.orderSort.length) {
        url = url + `?sortField=${this.orderSort}&sortDest=${this.directionSort ? "asc" : "desc"}`;
      }

      const data = {
        parameters: {},
      };

      if (this.filterData.id.length) {
        data.parameters.id = this.filterData.id;
      }

      if (this.filterData.first_name.length) {
        data.parameters.first_name = this.filterData.first_name;
      }

      if (this.filterData.last_name.length) {
        data.parameters.last_name = this.filterData.last_name;
      }

      if (this.filterData.email.length) {
        data.parameters.email = this.filterData.email;
      }

      if (this.filterData.campaign_internal.length) {
        data.parameters.campaign_internal = this.filterData.campaign_internal;
      }
      if (this.filterData.campaign_external.length) {
        data.parameters.campaign_external = this.filterData.campaign_external;
      }

      if (this.filterData.integration.length > 0) {
        const ids = this.filterData.integration;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.integration_id = idsArray;
      }

      if (this.filterData.direction.length > 0) {
        const ids = this.filterData.direction;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.direction = idsArray;
      }

      if (this.filterData.exclude_integration.length > 0) {
        const ids = this.filterData.exclude_integration;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.exclude_integration_id = idsArray;
      }

      if (this.filterData.country.length > 0) {
        const ids = this.filterData.country;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.country_id = idsArray;
      }

      if (this.filterData.exclude_country.length > 0) {
        const ids = this.filterData.exclude_country;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.exclude_country_id = idsArray;
      }

      if (this.filterData.language_id.length > 0) {
        const ids = this.filterData.language_id;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.language_id = idsArray;
      }

      if (this.filterData.phone.length) {
        data.parameters.phone = this.filterData.phone;
      }

      if (this.filterData.deposit != null && this.filterData.deposit.id != "all") {
        data.parameters.deposit = this.filterData.deposit.id == "1" ? true : false;
      }

      console.log(this.filterData);

      if (this.filterData.bayer.length > 0) {
        const ids = this.filterData.bayer;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.buyer_id = idsArray;
      }

      if (this.filterData.team.length > 0) {
        const ids = this.filterData.team;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.team_id = idsArray;
      }

      if (this.filterData.status.length > 0) {
        const ids = this.filterData.status;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.status_id = idsArray;
      }

      if (this.filterData.created_at_from) {
        data.parameters.created_at_from = moment(this.filterData.created_at_from).format(
          "YYYY-MM-DD",
        );
      }

      if (this.filterData.created_at_to) {
        data.parameters.created_at_to = moment(this.filterData.created_at_to).format("YYYY-MM-DD");
      }

      leadApi
        .getCountryDeposit(url, data)
        .then((res) => {
          this.$store.commit("lead/setLoading", false);
          const items = res.data.items.metricsByCountry;
          items.forEach((elem, index) => {
            elem.country_name = elem.countryName;
            elem.cr_leads = elem.crLeads;
            elem.cr_mtm = elem.crMtm;
            elem.ftd_mtm = elem.ftdMtm;
            elem.percent_of_leads = elem.percentOfLeads;
            elem.percent_of_ftd = elem.percentOfFtd;
            elem.percent_of_ftd_mtm = elem.percentOfFtdMtm;
          });
          this.leadsList = items;
          this.statistics = res.data.items.metrics;
        })
        .catch((error) => {
          this.$store.commit("lead/setLoading", false);
          console.log(error);
        });
    },
    filterList() {
      this.isFilter = true;
      this.handleSetQueryParams();
    },
    handleSetQueryParams() {
      const filter = {};
      if (this.filterData.id.length > 0) {
        filter.id = this.filterData.id;
      }
      if (this.filterData.first_name.length > 0) {
        filter.first_name = this.filterData.first_name;
      }
      if (this.filterData.last_name.length > 0) {
        filter.last_name = this.filterData.last_name;
      }
      if (this.filterData.email.length > 0) {
        filter.email = this.filterData.email;
      }
      if (this.filterData.campaign_external.length > 0) {
        filter.campaign_external = this.filterData.campaign_external;
      }
      if (this.filterData.campaign_internal.length > 0) {
        filter.campaign_internal = this.filterData.campaign_internal;
      }
      if (this.filterData.phone.length > 0) {
        filter.phone = this.filterData.phone;
      }

      if (this.filterData.integration.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.integration.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.integration_id = ids.join(",");
        filter.integration_name = name.join(",");
      }

      if (this.filterData.direction.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.direction.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.direction = ids.join(",");
        filter.direction_name = name.join(",");
      }

      if (this.filterData.exclude_integration.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.exclude_integration.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.exclude_integration_id = ids.join(",");
        filter.exclude_integration_name = name.join(",");
      }

      if (this.filterData.country.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.country.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.enName);
        });

        filter.country_id = ids.join(",");
        filter.country_name = name.join(",");
      }

      if (this.filterData.exclude_country.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.exclude_country.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.enName);
        });

        filter.exclude_country_id = ids.join(",");
        filter.exclude_country_name = name.join(",");
      }

      if (this.filterData.language_id.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.language_id.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.code);
        });

        filter.language_id = ids.join(",");
        filter.language_name = name.join(",");
      }

      if (this.filterData.deposit != null && this.filterData.deposit.id != "all") {
        filter.deposit = this.filterData.deposit.id;
        filter.deposit_name = this.filterData.deposit.name;
      }

      if (this.filterData.bayer.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.bayer.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.email);
        });

        filter.bayer = ids.join(",");
        filter.bayer_name = name.join(",");
      }

      if (this.filterData.team.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.team.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.team = ids.join(",");
        filter.team_name = name.join(",");
      }

      if (this.filterData.status.length > 0) {
        const ids = [];
        const name = [];

        this.filterData.status.forEach((item, index) => {
          ids.push(item.id);
          name.push(item.name);
        });

        filter.status = ids.join(",");
        filter.status_name = name.join(",");
      }

      if (this.filterData.created_at_from != null) {
        filter.created_at_from = moment(this.filterData.created_at_from).format("YYYY-MM-DD");
      }

      if (this.filterData.created_at_to != null) {
        filter.created_at_to = moment(this.filterData.created_at_to).format("YYYY-MM-DD");
      }

      if (this.page != 1) {
        this.$router.push({
          path: ROUTE.COUNTRY_DEPOSIT.replace(":page", 1),
        });
      }
      this.$router.push({ name: "CountryDeposit", query: filter });
    },
    setQueryParams() {
      if (this.handleGetQueryParam("id")) {
        this.filterData.id = this.handleGetQueryParam("id");
        this.isFilter = true;
      }
      if (this.handleGetQueryParam("first_name")) {
        this.filterData.first_name = this.handleGetQueryParam("first_name");
        this.isFilter = true;
      }
      if (this.handleGetQueryParam("last_name")) {
        this.filterData.last_name = this.handleGetQueryParam("last_name");
        this.isFilter = true;
      }
      if (this.handleGetQueryParam("email")) {
        this.filterData.email = this.handleGetQueryParam("email");
        this.isFilter = true;
      }
      if (this.handleGetQueryParam("campaign_external")) {
        this.filterData.campaign_external = this.handleGetQueryParam("campaign_external");
        this.isFilter = true;
      }
      if (this.handleGetQueryParam("campaign_internal")) {
        this.filterData.campaign_internal = this.handleGetQueryParam("campaign_internal");
        this.isFilter = true;
      }
      if (this.handleGetQueryParam("phone")) {
        this.filterData.phone = this.handleGetQueryParam("phone");
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("integration_id")) {
        const ids = this.handleGetQueryParam("integration_id").split(",");
        const names = this.handleGetQueryParam("integration_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.integration.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("direction")) {
        const ids = this.handleGetQueryParam("direction").split(",");
        const names = this.handleGetQueryParam("direction_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.direction.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("exclude_integration_id")) {
        const ids = this.handleGetQueryParam("exclude_integration_id").split(",");
        const names = this.handleGetQueryParam("exclude_integration_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.exclude_integration.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("country_id")) {
        const ids = this.handleGetQueryParam("country_id").split(",");
        const names = this.handleGetQueryParam("country_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.country.push({
            id: ids[index],
            enName: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("exclude_country_id")) {
        const ids = this.handleGetQueryParam("exclude_country_id").split(",");
        const names = this.handleGetQueryParam("exclude_country_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.exclude_country.push({
            id: ids[index],
            enName: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("language_id")) {
        const ids = this.handleGetQueryParam("language_id").split(",");
        const names = this.handleGetQueryParam("language_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.language_id.push({
            id: ids[index],
            code: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("deposit")) {
        this.filterData.deposit = {
          id: +this.handleGetQueryParam("deposit"),
          name: this.handleGetQueryParam("deposit_name"),
        };
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("bayer")) {
        const ids = this.handleGetQueryParam("bayer").split(",");
        const names = this.handleGetQueryParam("bayer_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.bayer.push({
            id: ids[index],
            email: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("team")) {
        const ids = this.handleGetQueryParam("team").split(",");
        const names = this.handleGetQueryParam("team_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.team.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("status")) {
        const ids = this.handleGetQueryParam("status").split(",");
        const names = this.handleGetQueryParam("status_name").split(",");

        ids.forEach((items, index) => {
          this.filterData.status.push({
            id: ids[index],
            name: names[index],
          });
        });
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("created_at_from")) {
        this.filterData.created_at_from = moment(
          this.handleGetQueryParam("created_at_from"),
          "YYYY-MM-DD",
        ).toDate();
        this.isFilter = true;
      }

      if (this.handleGetQueryParam("created_at_to")) {
        this.filterData.created_at_to = moment(
          this.handleGetQueryParam("created_at_to"),
          "YYYY-MM-DD",
        ).toDate();
        this.isFilter = true;
      }

      this.getList();
    },
    handleGetQueryParam(param) {
      if (this.$route.query[param] != undefined) {
        return this.$route.query[param];
      } else {
        return null;
      }
    },
    filterListReset() {
      this.isFilter = false;

      this.$router.push({ name: "CountryDeposit", query: {} });
      if (this.page != 1) {
        this.$router.push({
          path: ROUTE.COUNTRY_DEPOSIT.replace(":page", 1),
        });
      }

      this.filterData.id = "";
      this.filterData.first_name = "";
      this.filterData.last_name = "";
      this.filterData.phone = "";
      this.filterData.campaign_internal = "";
      this.filterData.campaign_external = "";
      this.filterData.integration = [];
      this.filterData.exclude_integration = [];
      this.filterData.country = [];
      this.filterData.exclude_country = [];
      this.filterData.status = [];
      this.filterData.created_at_from = null;
      this.filterData.created_at_to = null;
      this.filterData.email = "";
      this.filterData.language_id = [];
      this.filterData.deposit = null;
      this.filterData.bayer = [];
      this.filterData.team = [];
      this.filterData.direction = [];
      this.getList();
    },
    handleFilter(column) {
      this.orderSort = column;
      if (this.directionSort === null) {
        this.directionSort = true;
      } else {
        this.directionSort = !this.directionSort;
      }
      this.getList();
    },
    handleDelete(row) {
      this.deleteModal = true;
      this.deleteRow = row;
    },
    handleCloseConfirmModal() {
      this.deleteModal = false;
    },
    handleCloseSuccessModal() {
      this.deleteModalSuccess = false;
    },
    handleDeleteRow() {
      const url = `/${this.deleteRow.id}`;
      this.$store.commit("lead/setLoading", true);
      leadApi
        .deleteLead(url)
        .then((res) => {
          this.$store.commit("lead/setLoading", false);
          if (res.success) {
            this.getList();
            this.handleCloseConfirmModal();
            this.deleteModalSuccess = true;
          }
        })
        .catch((error) => {
          this.$store.commit("lead/setLoading", false);
          console.log(error);
        });
    },
    handleEdit(row) {
      console.log(row);
    },
    getLogStatus() {
      leadApi
        .getLogStatus()
        .then((res) => {
          this.logStatus = res.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleDetail(row) {
      this.detailModal = true;
      this.chosenLead = this.leadsList.find((item) => item.id === row.id);

      if (row.id) {
        // const url = `?lead_id=${row.id}&integration_id=${row.integrationId}&with[0]=status&perPage=100`;
        const url = `?perPage=1000&page=1&sortField=log_created_at&sortDest=desc&entity_id=${row.id}`;

        leadApi
          .getLeadLog(url)
          .then((res) => {
            this.$store.commit("lead/setLoading", false);
            this.logList = res.data.data.map((item, index) => ({
              ...item,
              is_detail: false,
            }));
          })
          .catch((error) => {
            this.$store.commit("lead/setLoading", false);
            console.log(error);
          });
      }
    },
    exportLead(success = false) {
      this.$store.commit("lead/setLoading", true);

      const data = {
        parameters: {},
      };

      if (success) {
        data.is_by_success_lead = true;
      }

      if (this.filterData.id.length) {
        data.parameters.id = this.filterData.id;
      }

      if (this.filterData.first_name.length) {
        data.parameters.first_name = this.filterData.first_name;
      }

      if (this.filterData.last_name.length) {
        data.parameters.last_name = this.filterData.last_name;
      }

      if (this.filterData.email.length) {
        data.parameters.email = this.filterData.email;
      }

      if (this.filterData.campaign_internal.length) {
        data.parameters.campaign_internal = this.filterData.campaign_internal;
      }
      if (this.filterData.campaign_external.length) {
        data.parameters.campaign_external = this.filterData.campaign_external;
      }

      if (this.filterData.integration.length > 0) {
        const ids = this.filterData.integration;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.integration_id = idsArray;
      }

      if (this.filterData.exclude_country.length > 0) {
        const ids = this.filterData.exclude_country;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.exclude_country_id = idsArray;
      }

      if (this.filterData.language_id.length > 0) {
        const ids = this.filterData.language_id;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.language_id = idsArray;
      }

      if (this.filterData.country.length > 0) {
        const ids = this.filterData.country;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.country_id = idsArray;
      }

      if (this.filterData.phone.length) {
        data.parameters.phone = this.filterData.phone;
      }

      if (this.filterData.deposit != null && this.filterData.deposit.id != "all") {
        data.parameters.deposit = this.filterData.deposit.id == "1" ? true : false;
      }

      console.log(this.filterData);

      if (this.filterData.bayer.length > 0) {
        const ids = this.filterData.bayer;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.bayer_id = idsArray;
      }

      if (this.filterData.team.length > 0) {
        const ids = this.filterData.team;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.team_id = idsArray;
      }

      if (this.filterData.status.length > 0) {
        const ids = this.filterData.status;
        const idsArray = [];
        ids.forEach((item, index) => {
          idsArray.push(item.id);
        });
        data.parameters.status_id = idsArray;
      }

      if (this.filterData.created_at_from) {
        data.parameters.created_at_from = moment(this.filterData.created_at_from).format(
          "YYYY-MM-DD",
        );
      }

      if (this.filterData.created_at_to) {
        data.parameters.created_at_to = moment(this.filterData.created_at_to).format("YYYY-MM-DD");
      }

      leadApi
        .exportLead(data)
        .then((res) => {
          this.$store.commit("lead/setLoading", false);
        })
        .catch((error) => {
          this.$store.commit("lead/setLoading", false);
          console.log(error);
        });
    },

    handleCloseDetailModal() {
      this.detailModal = false;
      this.chosenLead = null;
      this.logList = null;
      this.sendData.integration = null;
    },
    closeModal() {
      this.error = null;
    },
    handleLogDetail(index, data) {
      console.log(this.logList);
      this.logList[index].is_detail = data;
    },
    changePerPage(data) {
      if (this.page != 1) {
        this.$router.push({
          path: ROUTE.COUNTRY_DEPOSIT.replace(":page", 1) + this.getQueryParameters,
        });
      }
      this.perPage = data;
      this.getList();
    },
    addCheckElement(key, value) {
      const foundObj = this.filterData[key].find((obj) => obj.id === value.id);
      if (foundObj == undefined) {
        this.filterData[key].push(value);
      }
    },
    removeCheckElement(key, value) {
      this.filterData[key] = this.filterData[key].filter((obj) => obj.id !== value.id);
    },
    resetCheck(key, reset) {
      this.filterData[key] = reset;
    },
  },
};
</script>

<style lang="scss" scoped>
.check-selector {
  position: relative;

  &__reset {
    position: absolute;
    left: 5px;
    cursor: pointer;
    top: 9px;
    z-index: 11;
  }

  &__list {
    display: none;
    position: absolute;
    top: calc(100% - 20px);
    left: -100px;
    min-width: calc(300px + 40px);
    max-width: 400px;
    max-height: 340px;
    z-index: 10;
    padding: 20px;
  }

  &__list-container {
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #3c2a1e;
    background: #fff;
    overflow-y: auto;
    max-height: 300px;
  }

  &__button {
    width: 170px;
    padding: 5px 5px 5px 30px;
    border: 1px solid #3c2a1e;
    border-radius: 5px;
    position: relative;
    height: 40px;
    display: flex;
    align-items: center;

    svg {
      margin-left: 10px;
    }
  }

  &__button-name {
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__list-item {
    padding: 5px 5px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    &:hover {
      background: #c7c3c0;
    }

    span {
      width: 20px;
      height: 20px;
      min-width: 20px;
      min-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #3c2a1e;
      font-size: 15px;
      font-weight: 700;
      color: #fff;
      border-radius: 50px;
      line-height: 1;
    }
  }

  &__check-items {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #3c2a1e;
    padding: 10px 0;
    margin-bottom: 10px;
  }

  &__check-item {
    padding: 5px;
    border-radius: 5px;
    background: #3c2a1e;
    color: #fff;
    margin: 0 5px 5px 0;
    cursor: pointer;
    display: flex;
    align-items: center;

    span {
      width: 20px;
      height: 20px;
      min-width: 20px;
      min-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      font-size: 15px;
      font-weight: 700;
      color: #3c2a1e;
      border-radius: 50px;
      margin-left: 10px;
      line-height: 1;
    }
  }

  &:hover {
    .check-selector__list {
      display: block !important;
    }
  }

  &:focus-within {
    .check-selector__list {
      display: block !important;
    }
  }
}
/deep/.custom-table__header,
/deep/.custom-table__row {
  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr !important;
}

.country /deep/.custom-table__header,
.country /deep/.custom-table__row {
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr !important;
}

/deep/.modal-container {
  max-width: 90vw !important;
  max-height: 90vh;
  height: fit-content;
  overflow-y: auto;
}

/deep/.delete .modal-container {
  max-width: none;
  max-height: none;
  width: fit-content;
  height: fit-content;
  overflow-y: auto;
}

/deep/.success .modal-container {
  max-width: 100% !important;
  width: 100%;
}

/deep/.delete .list__confirm {
  flex-direction: column;
}

/deep/.mx-datepicker {
  width: 100%;
}

.list {
  &__confirm {
    justify-content: flex-start;
    flex-direction: row;
  }

  &__confirm-column {
    width: 50%;
    padding: 0 10px;
  }

  &__confirm-title {
    padding: 0 0 30px;
    font-weight: 700;
    text-align: left;
  }

  &__modal-list-item {
    padding-bottom: 10px;
    font-size: 18px;
    word-wrap: break-word;
  }

  &__modal-log {
    padding: 10px;
    background: gainsboro;
    border-radius: 10px;
    margin-bottom: 10px;
  }

  &__modal-log-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__modal-log-date {
    font-size: 12px;
  }

  &__modal-log-status {
    font-size: 12px;
  }

  &__modal-log-type {
    padding: 5px;
    background: rgb(255, 255, 255);
    border-radius: 10px;
    width: fit-content;
    font-size: 12px;
  }

  &__modal-log-integration {
    font-size: 12px;
    padding: 5px;
    word-break: break-all;
  }

  &__filter {
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &__filter-item {
    width: 170px;
    margin-right: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;

    &.id {
      width: 100px;
    }

    input {
      padding: 5px 10px;
      font-size: 14px;
      width: 100%;
      height: 40px;
    }

    &.left {
      justify-content: flex-end;
      font-weight: 700;
    }
  }

  &__filter-button {
    width: fit-content;
    margin-right: 10px;
    padding-bottom: 10px;
  }

  &__modal-log-detail-button {
    padding: 10px 0;
    font-weight: 700;
    cursor: pointer;
  }

  &__modal-log-detail {
    background: rgb(39, 39, 39);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    overflow-y: auto;
  }

  &__modal-sent-title {
    padding: 10px 0;
    font-weight: 700;
  }

  &__modal-sent-button {
    padding-top: 10px;
  }

  &__per-page {
    display: flex;
    padding-right: 50px;
  }

  &__per-page-item {
    padding: 7px;
    background: rgb(136, 136, 136);
    color: #fff;
    border-radius: 5px;
    margin-right: 5px;
    font-weight: 700;
    cursor: pointer;

    &.active {
      background: #3c2a1e;
    }
  }

  &__check-buttons {
    display: flex;
  }

  &__check-button {
    margin-right: 10px;
  }
}
.pagination {
  display: flex;
  align-items: center;
}
</style>
